import styles from './index.module.less'
import { Scrollbars } from 'react-custom-scrollbars'
import { Button, Col, Input, Row, Spin, Tooltip } from 'antd'
import useWorkOrderStore from '@/store/workOrder.ts'
import { useShallow } from 'zustand/react/shallow'
import dayjs from 'dayjs'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'
// import microApp, { getActiveApps } from '@micro-zoe/micro-app'
import React, { useEffect, useMemo, useRef } from 'react'
import { debounce } from 'lodash-es'
import EmptySmall from '@/components/Empty/EmptySmall.tsx'
import { RedoOutlined, UndoOutlined } from '@ant-design/icons'
// import { navigatePage } from '@/common/utils.ts'
import microApp from '@micro-zoe/micro-app'
import { useSetState } from 'ahooks'
import { workOrderPath } from '@/utils/workOrderPath.ts'

const WorkOrderList = props => {
  const { onSelect } = props
  const navigate = useNavigate()
  const scrollerRef = useRef<any>()
  const scrollValues = useRef<any>(null)
  const prevTimer = useRef<any>()
  const prevFetchAfter = useRef<any>([])

  const itemMeasureRef = useRef<any>(null)

  const {
    storeData,
    selectItem,
    setKeywords,
    routeWorkOrderItem,
    reloadWorkOrderData,
    fetchWorkOrderPrev,
    fetchWorkOrderNext,
    routeBizWorkOrderItem,
  } = useWorkOrderStore(
    useShallow((state: any) => ({
      storeData: state.data,
      selectItem: state.selectItem,
      setKeywords: state.setKeywords,
      routeWorkOrderItem: state.routeWorkOrderItem,
      reloadWorkOrderData: state.reloadWorkOrderData,
      fetchWorkOrderPrev: state.fetchWorkOrderPrev,
      fetchWorkOrderNext: state.fetchWorkOrderNext,
      routeBizWorkOrderItem: state.routeBizWorkOrderItem,
    }))
  )

  const [state, setState] = useSetState({
    pullScrolling: false,
    overflowDict: {},
  })

  const stateKey = storeData.selectedTabKey + (storeData.selectedAppCode || '')

  useEffect(() => {
    scrollerRef.current?.scrollTop(10)
  }, [stateKey])

  useEffect(() => {
    const overflowDict = {}
    storeData.workOrderData.map(d => {
      const result = calcTextOverFlow(d.contentList)
      result.map(item => {
        if (item.overflow) {
          overflowDict[d.id + '_' + item.label] = item.overflow
        }
      })
      // TODO 重复代码优化
      const flowNameOverflow = calcTextOverFlow([
        { label: '当前节点', content: d.bizData?.flowName ?? '' },
      ])
      flowNameOverflow.map(item => {
        if (item.overflow) {
          overflowDict[d.id + '_' + 'flowName'] = item.overflow
        }
      })
    })
    setState({ overflowDict })
  }, [storeData.workOrderData])

  const navigateFlow = (item: any = {}) => {
    // console.log('navigateFlow', appCode, flowCode, taskId)
    routeWorkOrderItem(item, navigate)
  }

  const handleSelect = record => {
    if (!record.procDefKey && !record.procInstId) {
      if (
        [
          'awaitAssignDesignDepartment',
          'assignNewSalesMnrMessage',
          'assignDesignerMnrMessage',
        ].includes(record.workOrder?.bizType)
      ) {
        const clueId = record.workOrder.businessKey.split('_')[1]
        window.open(`/mos/saleOp/salesWorkBench/salesWorkBenchDetail/${clueId}?clueId=${clueId}`)
      } else if (workOrderPath[record.workOrder?.bizType]) {
        onSelect?.(record)
        selectItem(record)
        routeBizWorkOrderItem(record, navigate)
        reloadFlowApp()
      }
    } else {
      onSelect?.(record)
      selectItem(record)
      navigateFlow(record)
      reloadFlowApp()
    }
  }

  const reloadFlowApp = () => {
    setTimeout(() => {
      microApp.reload('flow', false).then(result => {
        if (result) {
          console.log('重新渲染成功')
        } else {
          console.log('重新渲染失败')
        }
      })
    }, 100)
  }

  const debouncedFetch = useMemo(
    () => debounce(fetchWorkOrderNext, 100),
    [storeData, fetchWorkOrderNext]
  )

  // const debouncedFetchPrev = useMemo(
  //   () => debounce(() => fetchWorkOrderPrev(), 100),
  //   [storeData, fetchWorkOrderPrev]
  // )

  const debounceFetchData = useMemo(() => debounce(reloadWorkOrderData, 200), [reloadWorkOrderData])

  const handleInput = e => {
    setKeywords(e.target.value)
    debounceFetchData()
  }

  const handleReload = () => {
    debounceFetchData()
  }

  const fixScrollTop = () => {
    clearInterval(prevTimer.current)

    prevTimer.current = setTimeout(() => {
      prevFetchAfter.current.map(fn => fn?.())
      prevFetchAfter.current.pop()
      setState({ pullScrolling: false })
    }, 100)
  }

  const pullWorkOrder = () => {
    setState({ pullScrolling: true })
    const scrollHeight = scrollerRef.current.getScrollHeight()
    // const item = storeData.workOrderData[0]
    fetchWorkOrderPrev?.().then(data => {
      if (!data.length) {
        prevFetchAfter.current.push(() => {
          scrollerRef.current.scrollTop(10)
        })
      } else {
        // setTimeout(() => {
        //
        // }, 0)
        const nextScrollHeight = scrollerRef.current.getScrollHeight()
        scrollerRef.current.scrollTop(nextScrollHeight - scrollHeight)
        setState({ pullScrolling: false })
      }
      fixScrollTop()
    })
  }

  const handleScrollFrame = values => {
    const clientHeight = scrollerRef.current.getClientHeight()
    const scrollHeight = scrollerRef.current.getScrollHeight()
    const scrollTop = scrollerRef.current.getScrollTop()

    if (values.top === 0) {
      pullWorkOrder()
    }

    if (scrollHeight - clientHeight - scrollTop < 10 && scrollValues.current?.top < values.top) {
      debouncedFetch?.()
    }

    scrollValues.current = values
  }

  const handleWheel = e => {
    if (e.deltaY < 0) {
      fixScrollTop()
      const values = scrollerRef.current.getValues()
      if (!state.pullScrolling && values.top <= 0) {
        pullWorkOrder()
      }
    } else {
      clearInterval(prevTimer.current)
    }
  }

  const calcTextOverFlow = result => {
    const { width } = itemMeasureRef.current.getBoundingClientRect()

    return result.map(d => {
      const div = document.createElement('div')
      div.style.display = 'inline-block'
      div.style.fontSize = '14px'
      div.style.whiteSpace = 'nowrap'
      div.innerHTML = d.label + '：' + d.value
      itemMeasureRef.current.appendChild(div)
      if (div.offsetWidth > width - 24) {
        d.overflow = true
      }
      div.remove()
      return d
    })
  }

  const renderCardItem = (item, overflowId) => {
    return (
      <div className={styles.contentItem}>
        <div className={styles.itemLabel}>{item.label ? `${item.label}：` : ''}</div>
        {item.label && state.overflowDict[overflowId] ? (
          <Tooltip title={item.value} placement="right">
            <div className={styles.itemValue}>{item.value}</div>
          </Tooltip>
        ) : (
          <div className={styles.itemValue}>{item.value}</div>
        )}
      </div>
    )
  }
  // 流程实例信息处理
  const processInstanceInfoFn = d => {
    const { todoTasks = [], taskIdentityLinks = [] } = d ?? {}
    const nameHandle = (list, field) => {
      let nameStr = ''
      for (let i = 0; i < list.length; i++) {
        nameStr += list[i][field] ? `/${list[i][field]}` : '-'
      }
      return nameStr?.startsWith('/') ? nameStr.substring(1) : nameStr
    }
    let processInstanceInfo = [
      {
        label: '当前节点：',
        value: nameHandle(todoTasks, 'name') || '-',
      },
      {
        label: '当前节点处理人：',
        value: nameHandle(taskIdentityLinks, 'name') || '-',
      },
    ]
    return processInstanceInfo
  }
  // console.log(
  //   'storeData.selectedItemId',
  //   storeData.selectedItemId,
  //   storeData.workOrderData.map(d => d.id)
  // )
  const showNoMore = storeData.workOrderData.length >= 5 || storeData.workOrderData.length === 0
  let stylesText = {
    whiteSpace: 'nowrap' /* 禁止换行 */,
    overflow: 'hidden' /* 超出部分隐藏 */,
    textOverflow: 'ellipsis' /* 显示省略号 */,
    display: 'block',
    maxWidth: '100%',
  }
  return (
    <div className={styles.workOrderData}>
      <Row gutter={10} wrap={false}>
        <Col flex={1}>
          <Input
            placeholder="请输入关键字搜索"
            value={storeData.keyword}
            onInput={handleInput}
            style={{ width: '100%', height: 32, padding: '4px 11px' }}
          />
        </Col>
        <Col>
          <Button icon={<RedoOutlined />} title="刷新" onClick={handleReload} />
        </Col>
      </Row>

      <Scrollbars
        ref={scrollerRef}
        autoHide
        style={{ height: 'calc(100% - 36px)' }}
        renderTrackHorizontal={() => <div></div>}
        onScrollFrame={handleScrollFrame}
        onWheel={handleWheel}
      >
        <div className={styles.workOrderList}>
          <div
            className={styles.pullLoading}
            style={!state.pullScrolling ? { height: 0, padding: 0 } : {}}
          >
            {storeData.loadingDict[stateKey] === 2 || state.pullScrolling ? '加载中...' : ''}
          </div>

          <div className={styles.itemMeasure} ref={itemMeasureRef}></div>

          <Spin
            spinning={storeData.loadingDict[stateKey] === 3}
            style={{ height: 'calc(100vh - 60px)', maxHeight: 'unset' }}
          >
            {storeData.workOrderData.map((d, i) => {
              const isSelected = storeData.selectedItemId == d.id
              const { state } = d?.processInstance ?? {}
              const stateObj = {
                ACTIVE: { value: '运行中', fsColor: 'fsActive' },
                COMPLETED: { value: '已结束', fsColor: 'fsCompleted' },
              }
              let processInstanceInfo: Array<any> = processInstanceInfoFn(d)
              return (
                <div
                  key={`order_data_${i}`}
                  className={classNames(styles.workOrderItem, { [styles.selected]: isSelected })}
                  onClick={() => handleSelect(d)}
                  data-order={d.uid}
                >
                  <div className={styles.itemTitleSub}>
                    <span className={styles.title}>{d.title}</span>
                    <span className={styles[stateObj[state]?.fsColor]} style={{color: d.stateColor}}>
                      {d.stateText || stateObj[state]?.value}
                    </span>
                  </div>
                  <div>
                    {/*{renderCardItem({label: '当前节点', value: d.bizData?.flowNodeName ?? ''}, d.id + '_' + 'flowName')}*/}
                    {d.contentList?.map?.((item, j) => (
                      <React.Fragment key={`item_${j}`}>
                        {renderCardItem(item, d.id + '_' + item.label)}
                      </React.Fragment>
                    ))}
                  </div>
                  {state == 'ACTIVE' &&
                    processInstanceInfo?.map?.((item, i) => {
                      return (
                        <div className={styles.contentItem} key={i}>
                          <div className={styles.itemLabel}>{item?.label}</div>
                          <div className={styles.itemValue}>
                            <Tooltip title={item?.value}>
                              <span style={stylesText}>{item?.value}</span>
                            </Tooltip>
                          </div>
                        </div>
                      )
                    })}
                  <div className={styles.itemFooter} style={{ marginTop: 10 }}>
                    <Row wrap={false} align="middle" justify="space-between" gutter={8}>
                      {/* <Col className={styles.itemFooterText} style={{color: 'red', fontSize: '12px', fontWeight: 600}}> */}
                      {/*{d.procPrevNodeAuditor ? `[${d.procPrevNodeAuditor}]` : ''}*/}
                      {/* {d.bizData?.flowNodeName ? `节点：[${d.bizData.flowNodeName}]` : ''}
                      </Col> */}
                      <Col
                        className={styles.itemFooterText}
                        style={{ flexShrink: 0, fontSize: '12px', color: '#888' }}
                      >
                        {dayjs(d.createdTime).format('YYYY-MM-DD HH:mm')}
                      </Col>
                    </Row>
                  </div>
                </div>
              )
            })}
          </Spin>
          <div className={styles.listState}>
            {showNoMore && storeData.noMoreDict[stateKey] && !storeData.loadingDict[stateKey]
              ? '没有更多了'
              : ''}
            {storeData.loadingDict[stateKey] === 1 ? '加载中...' : ''}
          </div>

          {storeData.loadingDict[stateKey] !== 1 && !storeData.workOrderData.length ? (
            <EmptySmall style={{ top: '100%' }} />
          ) : null}
        </div>
      </Scrollbars>
    </div>
  )
}

export default WorkOrderList
